module.exports = __webpack_public_path__ + "static/img/14010005.96f2e1ee.png";